module.exports = new __parcel__URL__("BrickCinema.4c27da8b.avif").toString();